module.exports = __webpack_public_path__ + "img/een-logo.d785d272.png";